module.exports = __webpack_public_path__ + "img/img_promotion_bnr_internet_kt.aade5638.png";